export default "__VITE_ASSET__JRhRd9Bt__"